"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuSplitGroup: function() {
        return _index.MenuSplitGroup;
    },
    menuSplitGroupClassNames: function() {
        return _index.menuSplitGroupClassNames;
    },
    renderMenuSplitGroup_unstable: function() {
        return _index.renderMenuSplitGroup_unstable;
    },
    useMenuSplitGroupStyles_unstable: function() {
        return _index.useMenuSplitGroupStyles_unstable;
    },
    useMenuSplitGroup_unstable: function() {
        return _index.useMenuSplitGroup_unstable;
    }
});
const _index = require("./components/MenuSplitGroup/index");
